import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Scroll to the #section in the URL after navigation, or to the top of a new page. */
export const ScrollManager = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }
    document.getElementById(decodeURIComponent(hash.slice(1)))?.scrollIntoView({ behavior: 'smooth' });
  }, [pathname, hash]);

  return null;
};
